import { faker } from '@faker-js/faker'

import { PurchaseAgreement, PurchaseAgreementDetail } from '../../contracts/purchase'
import { asBuilder } from '../asBuilder'

export const getAgreement = asBuilder<PurchaseAgreement>((): PurchaseAgreement => {
  return {
    exists: faker.datatype.boolean(),
  }
})

export const getAgreementDetails = asBuilder<PurchaseAgreementDetail>((): PurchaseAgreementDetail => {
  return {
    id: faker.number.int(),
    term: faker.lorem.sentence(),
    userId: faker.number.int(),
    hospitalId: faker.number.int(),
    agreedAt: faker.date.recent().toISOString(),
  }
})
